'use strict';

var _toConsumableArray = require("/Users/bryan/Documents/Projects/ssat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/bryan/Documents/Projects/ssat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var calculateTotalDuration = function calculateTotalDuration(_ref) {
  var _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0.3 : _ref$duration,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? 0 : _ref$overlay;
  return duration + delay - overlay || 0;
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

function getSequenceId(sequenceIndex, sequenceId, defaultValue) {
  if (isUndefined(sequenceId) && isUndefined(sequenceIndex)) {
    return defaultValue || 0;
  }

  if (sequenceIndex && sequenceIndex >= 0) {
    return sequenceIndex;
  }

  if (sequenceId) {
    return sequenceId;
  }

  return 0;
}

var DEFAULT_DURATION = 0.3;
var DEFAULT_EASE_TYPE = 'linear';
var DEFAULT_DIRECTION = 'normal';
var DEFAULT_FILLMODE = 'none';
var RUNNING = 'running';
var ALL = 'all';
var AnimateContext = React.createContext({
  animationStates: {},
  register: function register(data) {}
});

function AnimateGroup(_ref2) {
  var play = _ref2.play,
      _ref2$sequences = _ref2.sequences,
      sequences = _ref2$sequences === void 0 ? [] : _ref2$sequences,
      children = _ref2.children;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      animationStates = _React$useState2[0],
      setAnimationStates = _React$useState2[1];

  var animationsRef = React.useRef({});
  var register = React.useCallback(function (data) {
    var sequenceIndex = data.sequenceIndex,
        sequenceId = data.sequenceId;

    if (!isUndefined(sequenceId) || !isUndefined(sequenceIndex)) {
      animationsRef.current[getSequenceId(sequenceIndex, sequenceId)] = data;
    }
  }, []);
  React.useEffect(function () {
    var sequencesToAnimate = Array.isArray(sequences) && sequences.length ? sequences : Object.values(animationsRef.current);
    var localAnimationState = {};
    (play ? sequencesToAnimate : _toConsumableArray(sequencesToAnimate).reverse()).reduce(function (previous, _ref3, currentIndex) {
      var sequenceId = _ref3.sequenceId,
          sequenceIndex = _ref3.sequenceIndex,
          _ref3$duration = _ref3.duration,
          duration = _ref3$duration === void 0 ? DEFAULT_DURATION : _ref3$duration,
          delay = _ref3.delay,
          overlay = _ref3.overlay;
      var id = getSequenceId(sequenceIndex, sequenceId, currentIndex);
      var currentTotalDuration = calculateTotalDuration({
        duration: duration,
        delay: delay,
        overlay: overlay
      });
      var totalDuration = currentTotalDuration + previous;
      localAnimationState[id] = {
        play: play,
        pause: !play,
        delay: currentIndex === 0 ? delay || 0 : delay ? previous + delay : previous,
        controlled: true
      };
      return totalDuration;
    }, 0);
    setAnimationStates(localAnimationState); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play]);
  return React.createElement(AnimateContext.Provider, {
    value: {
      animationStates: animationStates,
      register: register
    }
  }, children);
}

var secToMs = function secToMs(ms) {
  return (ms || 0) * 1000;
};

function Animate(props) {
  var play = props.play,
      children = props.children,
      render = props.render,
      start = props.start,
      end = props.end,
      _props$complete = props.complete,
      complete = _props$complete === void 0 ? '' : _props$complete,
      onComplete = props.onComplete,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? DEFAULT_DURATION : _props$duration,
      _props$easeType = props.easeType,
      easeType = _props$easeType === void 0 ? DEFAULT_EASE_TYPE : _props$easeType,
      sequenceId = props.sequenceId,
      sequenceIndex = props.sequenceIndex;
  var onCompleteTimeRef = React.useRef();

  var _React$useState3 = React.useState(start || {}),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      style = _React$useState4[0],
      setStyle = _React$useState4[1];

  var _React$useContext = React.useContext(AnimateContext),
      register = _React$useContext.register,
      _React$useContext$ani = _React$useContext.animationStates,
      animationStates = _React$useContext$ani === void 0 ? {} : _React$useContext$ani;

  var id = getSequenceId(sequenceIndex, sequenceId);
  React.useEffect(function () {
    if (!isUndefined(sequenceIndex) && sequenceIndex >= 0 || sequenceId) {
      register(props);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  React.useEffect(function () {
    var animationState = animationStates[id] || {};
    setStyle(Object.assign(Object.assign({}, play || animationState.play ? end : start), {
      transition: "".concat(ALL, " ").concat(duration, "s ").concat(easeType, " ").concat(parseFloat(animationState.delay || delay), "s")
    }));

    if (play && (complete || onComplete)) {
      onCompleteTimeRef.current = setTimeout(function () {
        complete && setStyle(complete);
        onComplete && onComplete();
      }, secToMs(parseFloat(animationState.delay || delay) + duration));
    }

    return function () {
      return onCompleteTimeRef.current && clearTimeout(onCompleteTimeRef.current);
    };
  }, [id, animationStates, play, duration, easeType, delay, onComplete, start, end, complete]);
  return render ? render({
    style: style
  }) : React.createElement("div", {
    style: style
  }, children);
}

var camelCaseToDash = function camelCaseToDash(camelCase) {
  return camelCase ? camelCase.replace(/[A-Z]/g, function (c) {
    return "-".concat(c.toLowerCase());
  }) : '';
};

var generateKeyframes = function generateKeyframes(keyframes) {
  var animationLength = keyframes.length;
  return keyframes.reduce(function (previous, keyframe, currentIndex) {
    var keyframePercentage = animationLength === 2 ? currentIndex * 100 : parseFloat((100 / (animationLength - 1)).toFixed(2)) * currentIndex;

    if (typeof keyframe === 'string') {
      return "".concat(previous, " ").concat(keyframePercentage, "% {").concat(keyframe, "}");
    }

    var keys = Object.keys(keyframe);

    if (keys.length && isNaN(+keys[0])) {
      var keyframeContent = keys.reduce(function (acc, key) {
        return "".concat(acc, " ").concat(camelCaseToDash(key), ": ").concat(keyframe[key], ";");
      }, '');
      return "".concat(previous, " ").concat(keyframePercentage, "% {").concat(keyframeContent, "}");
    }

    return "".concat(previous, " ").concat(Object.keys(keyframe)[0], "% {").concat(Object.values(keyframe)[0], "}");
  }, '');
};

function createStyle(_ref4) {
  var keyframes = _ref4.keyframes,
      animationName = _ref4.animationName;
  return "@keyframes ".concat(animationName, " {").concat(generateKeyframes(keyframes), "}");
}

function createTag(_ref5) {
  var keyframes = _ref5.keyframes,
      animationName = _ref5.animationName;
  var styleTag = document.querySelector('style[data-id=rsi]');
  var index;

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.setAttribute('data-id', 'rsi');
    document.head.appendChild(styleTag);
  }

  try {
    // @ts-ignore
    index = styleTag.sheet.cssRules.length;
  } catch (e) {
    index = 0;
  }

  try {
    // @ts-ignore
    styleTag.sheet.insertRule(createStyle({
      keyframes: keyframes,
      animationName: animationName
    }), index);
  } catch (e) {
    console.error('react simple animate, error found during insert style ', e); // eslint-disable-line no-console
  }

  return {
    styleTag: styleTag,
    index: index
  };
}

var deleteRules = function deleteRules(sheet, deleteName) {
  var index = Object.values(sheet.cssRules).findIndex(function (_ref6) {
    var name = _ref6.name;
    return name === deleteName;
  });

  if (index >= 0) {
    sheet.deleteRule(index);
  }
};

var createRandomName = function createRandomName() {
  return "RSI-".concat(Math.random().toString(36).substr(2, 9));
};

var getPlayState = function getPlayState(pause) {
  return pause ? 'paused' : RUNNING;
};

function AnimateKeyframes(props) {
  var children = props.children,
      _props$play = props.play,
      play = _props$play === void 0 ? false : _props$play,
      _props$pause = props.pause,
      pause = _props$pause === void 0 ? false : _props$pause,
      render = props.render,
      _props$duration2 = props.duration,
      duration = _props$duration2 === void 0 ? DEFAULT_DURATION : _props$duration2,
      _props$delay2 = props.delay,
      delay = _props$delay2 === void 0 ? 0 : _props$delay2,
      _props$easeType2 = props.easeType,
      easeType = _props$easeType2 === void 0 ? DEFAULT_EASE_TYPE : _props$easeType2,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? DEFAULT_DIRECTION : _props$direction,
      _props$fillMode = props.fillMode,
      fillMode = _props$fillMode === void 0 ? DEFAULT_FILLMODE : _props$fillMode,
      _props$iterationCount = props.iterationCount,
      iterationCount = _props$iterationCount === void 0 ? 1 : _props$iterationCount,
      sequenceIndex = props.sequenceIndex,
      keyframes = props.keyframes,
      sequenceId = props.sequenceId;
  var pauseValue;
  var animationNameRef = React.useRef({
    forward: '',
    reverse: ''
  });
  var controlled = React.useRef(false);
  var styleTagRef = React.useRef({
    forward: {
      sheet: {}
    },
    reverse: {
      sheet: {}
    }
  });
  var id = getSequenceId(sequenceIndex, sequenceId);

  var _React$useContext2 = React.useContext(AnimateContext),
      register = _React$useContext2.register,
      _React$useContext2$an = _React$useContext2.animationStates,
      animationStates = _React$useContext2$an === void 0 ? {} : _React$useContext2$an;

  var animateState = animationStates[id] || {};

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      forceUpdate = _React$useState6[1];

  React.useEffect(function () {
    var styleTag = styleTagRef.current;
    var animationName = animationNameRef.current;
    animationNameRef.current.forward = createRandomName();
    var result = createTag({
      animationName: animationNameRef.current.forward,
      keyframes: keyframes
    });
    animationNameRef.current.reverse = createRandomName();
    styleTagRef.current.forward = result.styleTag;
    result = createTag({
      animationName: animationNameRef.current.reverse,
      keyframes: keyframes.reverse()
    });
    styleTagRef.current.reverse = result.styleTag;
    register(props);

    if (play) {
      forceUpdate(true);
    }

    return function () {
      deleteRules(styleTag.forward.sheet, animationName.forward);
      deleteRules(styleTag.reverse.sheet, animationName.reverse);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (animateState.controlled && !controlled.current) {
    pauseValue = animateState.pause;

    if (!animateState.pause) {
      controlled.current = true;
    }
  } else {
    pauseValue = pause;
  }

  var style = {
    animation: "".concat(duration, "s ").concat(easeType, " ").concat(animateState.delay || delay, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(getPlayState(pauseValue), " ").concat(((animateState.controlled ? animateState.play : play) ? animationNameRef.current.forward : animationNameRef.current.reverse) || '')
  };
  return render ? render({
    style: style
  }) : React.createElement("div", {
    style: style || {}
  }, children);
}

function useAnimate(props) {
  var start = props.start,
      end = props.end,
      complete = props.complete,
      onComplete = props.onComplete,
      _props$delay3 = props.delay,
      delay = _props$delay3 === void 0 ? 0 : _props$delay3,
      _props$duration3 = props.duration,
      duration = _props$duration3 === void 0 ? DEFAULT_DURATION : _props$duration3,
      _props$easeType3 = props.easeType,
      easeType = _props$easeType3 === void 0 ? DEFAULT_EASE_TYPE : _props$easeType3;
  var transition = React.useMemo(function () {
    return "".concat(ALL, " ").concat(duration, "s ").concat(easeType, " ").concat(delay, "s");
  }, [duration, easeType, delay]);

  var _React$useState7 = React.useState({
    isPlaying: false,
    style: Object.assign(Object.assign({}, start), {
      transition: transition
    })
  }),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      animate = _React$useState8[0],
      setAnimate = _React$useState8[1];

  var isPlaying = animate.isPlaying,
      style = animate.style;
  var onCompleteTimeRef = React.useRef();
  React.useEffect(function () {
    if ((onCompleteTimeRef.current || complete) && isPlaying) {
      onCompleteTimeRef.current = setTimeout(function () {
        if (onComplete) {
          onComplete();
        }

        if (complete) {
          setAnimate(Object.assign(Object.assign({}, animate), {
            style: complete
          }));
        }
      }, secToMs(delay + duration));
    }

    return function () {
      return onCompleteTimeRef.current && clearTimeout(onCompleteTimeRef.current);
    };
  }, [isPlaying]);
  return {
    isPlaying: isPlaying,
    style: style,
    play: React.useCallback(function (isPlaying) {
      setAnimate(Object.assign(Object.assign({}, animate), {
        style: Object.assign(Object.assign({}, isPlaying ? end : start), {
          transition: transition
        }),
        isPlaying: isPlaying
      }));
    }, [])
  };
}

function useAnimateKeyframes(props) {
  var _props$duration4 = props.duration,
      duration = _props$duration4 === void 0 ? DEFAULT_DURATION : _props$duration4,
      _props$delay4 = props.delay,
      delay = _props$delay4 === void 0 ? 0 : _props$delay4,
      _props$easeType4 = props.easeType,
      easeType = _props$easeType4 === void 0 ? DEFAULT_EASE_TYPE : _props$easeType4,
      _props$direction2 = props.direction,
      direction = _props$direction2 === void 0 ? DEFAULT_DIRECTION : _props$direction2,
      _props$fillMode2 = props.fillMode,
      fillMode = _props$fillMode2 === void 0 ? DEFAULT_FILLMODE : _props$fillMode2,
      _props$iterationCount2 = props.iterationCount,
      iterationCount = _props$iterationCount2 === void 0 ? 1 : _props$iterationCount2,
      keyframes = props.keyframes;
  var animationNameRef = React.useRef({
    forward: '',
    reverse: ''
  });
  var styleTagRef = React.useRef({
    forward: {
      sheet: {}
    },
    reverse: {
      sheet: {}
    }
  });

  var _React$useContext3 = React.useContext(AnimateContext),
      register = _React$useContext3.register;

  var _React$useState9 = React.useState(null),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      isPlaying = _React$useState10[0],
      setIsPlaying = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      isPaused = _React$useState12[0],
      setIsPaused = _React$useState12[1];

  var playRef = React.useRef();
  React.useEffect(function () {
    var styleTag = styleTagRef.current;
    var animationName = animationNameRef.current;
    animationNameRef.current.forward = createRandomName();
    var result = createTag({
      animationName: animationNameRef.current.forward,
      keyframes: keyframes
    });
    styleTagRef.current.forward = result.styleTag;
    animationNameRef.current.reverse = createRandomName();
    result = createTag({
      animationName: animationNameRef.current.reverse,
      keyframes: keyframes.reverse()
    });
    styleTagRef.current.reverse = result.styleTag;
    register(props);
    return function () {
      deleteRules(styleTag.forward.sheet, animationName.forward);
      deleteRules(styleTag.reverse.sheet, animationName.reverse);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  playRef.current = playRef.current ? playRef.current : function (isPlay) {
    return setIsPlaying(isPlay);
  };
  var style = {
    animation: "".concat(duration, "s ").concat(easeType, " ").concat(delay, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(getPlayState(isPaused), " ").concat(isPlaying === null ? '' : isPlaying ? animationNameRef.current.forward : animationNameRef.current.reverse)
  };
  return {
    style: style,
    play: playRef.current,
    pause: setIsPaused,
    isPlaying: !!isPlaying
  };
}

function createArrayWithNumbers(length) {
  return Array.from({
    length: length
  }, function () {
    return null;
  });
}

function useAnimateGroup(props) {
  var _props$sequences = props.sequences,
      sequences = _props$sequences === void 0 ? [] : _props$sequences;
  var defaultArray = createArrayWithNumbers(sequences.length).map(function (_, index) {
    return props.sequences[index].start;
  });

  var _React$useState13 = React.useState(defaultArray),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      styles = _React$useState14[0],
      setStyles = _React$useState14[1];

  var _React$useState15 = React.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      isPlaying = _React$useState16[0],
      setPlaying = _React$useState16[1];

  var animationNamesRef = React.useRef([]);
  var styleTagRef = React.useRef([]);
  var playRef = React.useRef();
  React.useEffect(function () {
    sequences.forEach(function (_ref7, i) {
      var _ref7$keyframes = _ref7.keyframes,
          keyframes = _ref7$keyframes === void 0 ? false : _ref7$keyframes;

      if (!Array.isArray(keyframes)) {
        return;
      }

      if (!animationNamesRef.current[i]) {
        animationNamesRef.current[i] = {};
        styleTagRef.current[i] = {};
      }

      animationNamesRef.current[i].forward = createRandomName();
      var result = createTag({
        animationName: animationNamesRef.current[i].forward,
        keyframes: keyframes
      });
      styleTagRef.current[i].forward = result.styleTag;
      animationNamesRef.current[i].reverse = createRandomName();
      result = createTag({
        animationName: animationNamesRef.current[i].reverse,
        keyframes: keyframes.reverse()
      });
      styleTagRef.current[i].reverse = result.styleTag;
    });
    return function () {
      return Object.values(animationNamesRef).forEach(function (_ref8, i) {
        var forward = _ref8.forward,
            reverse = _ref8.reverse;

        if (!styleTagRef[i]) {
          return;
        }

        deleteRules(styleTagRef[i].sheet, forward);
        deleteRules(styleTagRef[i].sheet, reverse);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  playRef.current = playRef.current ? playRef.current : function (isPlay) {
    var totalDuration = 0;
    var animationRefWithOrder = isPlay ? animationNamesRef.current : _toConsumableArray(animationNamesRef.current).reverse();
    var styles = (isPlay ? sequences : _toConsumableArray(sequences).reverse()).map(function (current, currentIndex) {
      var _current$duration = current.duration,
          duration = _current$duration === void 0 ? DEFAULT_DURATION : _current$duration,
          _current$delay = current.delay,
          delay = _current$delay === void 0 ? 0 : _current$delay,
          overlay = current.overlay,
          keyframes = current.keyframes,
          _current$iterationCou = current.iterationCount,
          iterationCount = _current$iterationCou === void 0 ? 1 : _current$iterationCou,
          _current$easeType = current.easeType,
          easeType = _current$easeType === void 0 ? DEFAULT_EASE_TYPE : _current$easeType,
          _current$direction = current.direction,
          direction = _current$direction === void 0 ? DEFAULT_DIRECTION : _current$direction,
          _current$fillMode = current.fillMode,
          fillMode = _current$fillMode === void 0 ? DEFAULT_FILLMODE : _current$fillMode,
          _current$end = current.end,
          end = _current$end === void 0 ? {} : _current$end,
          _current$start = current.start,
          start = _current$start === void 0 ? {} : _current$start;
      var delayDuration = currentIndex === 0 ? delay : totalDuration;
      var transition = "".concat(ALL, " ").concat(duration, "s ").concat(easeType, " ").concat(delayDuration, "s");
      totalDuration = calculateTotalDuration({
        duration: duration,
        delay: delay,
        overlay: overlay
      }) + totalDuration;
      return keyframes ? {
        animation: "".concat(duration, "s ").concat(easeType, " ").concat(delayDuration, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(RUNNING, " ").concat(isPlay ? animationRefWithOrder[currentIndex].forward : animationRefWithOrder[currentIndex].reverse)
      } : Object.assign(Object.assign({}, isPlay ? end : start), {
        transition: transition
      });
    });
    setStyles(isPlay ? styles : _toConsumableArray(styles).reverse());
    setPlaying(!isPlaying);
  };
  return {
    styles: styles,
    play: playRef.current,
    isPlaying: isPlaying
  };
}

exports.Animate = Animate;
exports.AnimateGroup = AnimateGroup;
exports.AnimateKeyframes = AnimateKeyframes;
exports.useAnimate = useAnimate;
exports.useAnimateGroup = useAnimateGroup;
exports.useAnimateKeyframes = useAnimateKeyframes;